import { Box, Typography } from "@mui/material";

import LendingOverviewSection from "../LendingOverviewSection";
import MehrsanOverviewSection from "../MehrsanOverviewSection";
import LendingKpiRow from "../components/LendingKpiRow";
import LoanPartnerPerformanceTable from "../components/LoanPartnerPerformanceTable";

const LendingFinanceTab = ({
  lendingLoading,
  lendingError,
  lendingData,
  mehrsanLoading,
  mehrsanError,
  mehrsanData,
  loanPartnerPerfLoading,
  loanPartnerPerfError,
  loanPartnerPerfData,
  dashboardFilters,
  loadLending,
  loadMehrsan,
  loadLoanPartnerPerformance,
}) => (
  <Box>
    <Typography fontWeight={700} fontSize={16} sx={{ mb: 1.5 }}>
      شاخص‌های وام و مالی
    </Typography>
    <LendingKpiRow
      data={lendingData}
      loading={lendingLoading}
      error={lendingError}
      onRetry={() => loadLending(dashboardFilters)}
    />

    <LoanPartnerPerformanceTable
      loading={loanPartnerPerfLoading}
      error={loanPartnerPerfError}
      data={loanPartnerPerfData}
      onRetry={() => loadLoanPartnerPerformance(dashboardFilters)}
    />

    <LendingOverviewSection
      loading={lendingLoading}
      error={lendingError}
      data={lendingData}
      onRetry={() => loadLending(dashboardFilters)}
    />

    <MehrsanOverviewSection
      loading={mehrsanLoading}
      error={mehrsanError}
      data={mehrsanData}
      onRetry={() => loadMehrsan(dashboardFilters)}
    />
  </Box>
);

export default LendingFinanceTab;
